import { Link } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { FinalCTA } from "@/components/home/FinalCTA";
import { cities } from "@/data/areas";
import { generateBreadcrumbSchema } from "@/lib/structuredData";
import { MapPin } from "lucide-react";

export default function AreasIndex() {
  const structuredData = [
    generateBreadcrumbSchema([
      { name: "Home", url: "https://bookkeepingservices.co.za/" },
      { name: "Areas We Serve", url: "https://bookkeepingservices.co.za/areas" },
    ]),
  ];

  return (
    <Layout>
      <SEO
        title="Areas We Serve | Bookkeeping Services South Africa"
        description="Remote bookkeeping, payroll, tax and SARS compliance for businesses across Cape Town, Johannesburg and Durban. Explore the areas we serve."
        canonical="/areas"
        structuredData={structuredData}
      />

      <Breadcrumbs items={[{ name: "Areas We Serve" }]} />

      <section className="py-16 lg:py-24 section-accent">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
            Areas We Serve
          </h1>
          <p className="text-lg text-muted-foreground leading-relaxed">
            We work remotely with businesses across South Africa's major metros.
            Choose your city below for local business context, or contact us for a quote.
          </p>
        </div>
      </section>

      <section className="py-20 section-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {cities.map((c) => (
              <Link
                key={c.slug}
                to={`/areas/${c.slug}`}
                className="block p-8 rounded-2xl border border-border bg-white hover:border-primary hover:shadow-md transition-all"
              >
                <MapPin className="w-6 h-6 text-primary mb-4" />
                <h2 className="font-heading text-2xl font-bold text-foreground mb-2">
                  {c.name}
                </h2>
                <p className="text-sm text-muted-foreground mb-4">{c.province}</p>
                <p className="text-sm text-muted-foreground leading-relaxed line-clamp-4">
                  {c.intro}
                </p>
                <span className="inline-block mt-4 text-primary text-sm font-medium">
                  View {c.name} areas →
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <FinalCTA />
    </Layout>
  );
}
